"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = exports.merge = exports.isObject = void 0;
function isObject(val) {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
}
exports.isObject = isObject;
function _merge(target, source) {
    if (!isObject(target) || !isObject(source))
        return target;
    for (const key of Object.keys(source)) {
        const srcVal = source[key];
        const tgtVal = target[key];
        if (Array.isArray(srcVal) && Array.isArray(tgtVal)) {
            target[key] = tgtVal.concat(srcVal);
        }
        else if (isObject(srcVal) && isObject(tgtVal)) {
            _merge(tgtVal, srcVal);
        }
        else {
            target[key] = srcVal;
        }
    }
    return target;
}
function merge(target, ...sources) {
    return sources.reduce((previous, current) => {
        return _merge(previous, current);
    }, target);
}
exports.merge = merge;
function isEqual(a, b) {
    if (a === b)
        return true;
    if (typeof a !== typeof b || a == null || b == null)
        return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length)
            return false;
        return a.every((val, i) => isEqual(val, b[i]));
    }
    if (typeof a === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length)
            return false;
        return aKeys.every(key => b.hasOwnProperty(key) && isEqual(a[key], b[key]));
    }
    return false;
}
exports.isEqual = isEqual;
//# sourceMappingURL=object.js.map